// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"W_-z","colorTextValue":"X_-z","swatches":"Y_-z","collapseLink":"Z_-z","isCollapsed":"__-z","dropdown":"aaa-z","disabled":"baa-z"};